import { all } from 'redux-saga/effects';
import claimsSaga from '../redux/Claims/saga';
import authSaga from '../redux/Authentication/saga';
import policyDetailsSaga from '../redux/PolicyDetails/saga';
import servicesSaga from '../redux/Services/saga';

export default function* rootSaga() {
  yield all([
    claimsSaga(),
    authSaga(),
    policyDetailsSaga(),
    servicesSaga(),
  ]);
}
